import { Mask } from '../mask/index'
import Vue, {ref} from 'vue'
let mask = null
import { Loading } from 'vant';
import { messages } from '@/i18n'
import { getPathLang } from '@/utils/base'


Vue.use(Loading);
export const toast = (text = messages[getPathLang()]['go_to_pay']) => {
    mask = new Mask({
        maskClass: ['flex-center', 'z-10000', '__pay-toast__'],
        closeOnClickOverlay: false,
        isScroll: true,
        slot: () => {
            return Vue.extend({
                render(){
                    return <div class={['flex-center', 'flex-col', 'radius-12', 'text-center', 'color-fff']} style={'width: 150px; height:150px; background-color:rgba(0, 0, 0, 0.5);'}>
                        <van-loading />
                        <div class={['mt-20']}>{text}</div>
                    </div>
                },
            })
        }
    });
    mask.init();
    mask.show();
    setTimeout(() => {
        console.log('close')
        closeToast();
    }, 30000)
}

export const closeToast = () => {
    if(mask){
        mask.destroy();
        mask = null;
    }
}